import { useSelector, useDispatch } from 'react-redux'
import { RootState, AppDispatch } from '../store'
import { login, logout, verifyToken } from '../store/authSlice'
import { LoginCredentials } from '../types/user.types'

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { user, isAuthenticated, isLoading, error } = useSelector((state: RootState) => state.auth)

  const handleLogin = async (credentials: LoginCredentials) => {
    return dispatch(login(credentials))
  }

  const handleLogout = async () => {
    return dispatch(logout())
  }

  const handleVerifyToken = async () => {
    return dispatch(verifyToken())
  }

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login: handleLogin,
    logout: handleLogout,
    verifyToken: handleVerifyToken
  }
}
